<template>
  <div class="delete-modal">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible="visible"
      width="558px"
      :before-close="handleClose"
    >
      <div class="modal-tipsbox">
        <span class="el-icon-warning tip-icon"></span>
        <div v-if="info.authorize">
          <p class="del-title">{{$t('user.oauth.tip1')}} {{ this.info.app }} {{$t('user.oauth.tip2')}}?</p>
          <p class="del-subtitle">
            {{$t('user.oauth.tip3')}}
          </p>
        </div>
        <div v-else>
          <p class="del-title">{{$t('user.oauth.tip5')}} {{ this.info.app }} {{$t('user.oauth.tip2')}}?</p>
          <p class="del-subtitle">
            {{$t('user.oauth.tip4')}}
          </p>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{$t('user.oauth.cancel')}}</el-button>
        <el-button type="primary" @click="confirm(info)">{{
          this.info.authorize ? $t('user.oauth.unAuth') : $t('user.oauth.auth')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      title: "Unauthorize",
      info: {
        authorize:false,
      },
      show: false,
    };
  },
  watch: {
    visible: {
      handler(n, o) {
        this.visible = n;
        this.title = this.info.authorize ? this.$t('user.oauth.unAuth') : this.$t('user.oauth.auth');
      },
    },
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
    showChange() {
      this.visible = !this.visible;
    },
    confirm(e) {
      if (e.authorize) {
          this.$http.post('/home/user/unOauth', {type:e.app}).then((res) => {
              res = res.data;
              if(res.code == 200){
                  this.$message({
                      message: res.message,
                      type: 'success'
                  })
                  this.visible = false;
                  this.$parent.getOauthList();
              }else{
                  this.$message({
                      message: res.message,
                      type: 'error'
                  })
              }
          }).catch((err) => {
              this.$message.error(err)
          })
      } else {
          window.location.href = process.env.YISU_API_URL+'/oauth/'+e.app+'/index?state=2';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
}

.modal-tipsbox {
  padding-left: 60px;
  position: relative;
  .tip-icon {
    width: 40px;
    height: 40px;
    font-size: 40px;
    color: #f7ba2a;
    position: absolute;
    left: 0;
    top: -2px;
  }
  .del-title {
    font-size: 14px;
    color: #2d3037;
    line-height: 12px;
    margin-bottom: 6px;
    span {
      color: #3377ff;
      margin: 0 4px;
    }
  }
  .del-subtitle {
    font-size: 14px;
    color: #5e6d81;
    line-height: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/Authorize.vue